// extracted by mini-css-extract-plugin
export default {"recos":"I5-z","productCardOverride":"J5-z","rowHasBadge":"K5-z"};